import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';
import { userApi } from './user-api';

export const selectIsAuth = createSelector(
  [(state: RootState) => state.auth],
  (auth) => auth.isAuth,
);

export const selectRedirectUrl = createSelector(
  [(state: RootState) => state.auth],
  (auth) => auth.redirectUrl,
);

export const selectUser = createSelector(
  [userApi.endpoints.getUserData.select()],
  (result) => result.data ?? null,
);

export const selectUserAddressName = createSelector(
  [selectUser],
  (user) => user?.personalization?.addressName ?? '',
);

export const selectUserAddressType = createSelector(
  [selectUser],
  (user) => user?.personalization?.addressType ?? '',
);

export const selectUserInstruction = createSelector(
  [selectUser],
  (user) => user?.personalization?.instruction ?? '',
);

export const selectUserTheme = createSelector(
  [selectUser],
  (user) => user?.settings?.theme ?? null,
);

export const selectUserNotificationChannels = createSelector(
  [selectUser],
  (user) => user?.settings?.notificationChannels ?? [],
);

export const selectUserNewsAndUpdatesChannels = createSelector(
  [selectUser],
  (user) => user?.settings?.newsAndUpdatesChannels ?? [],
);

const selectUserSettingsOptionsResult =
  userApi.endpoints.getUserSettingsOptions.select();

export const selectNotificationChannels = createSelector(
  [selectUserSettingsOptionsResult],
  (result) => result.data?.notificationChannels ?? [],
);

export const selectNewsAndUpdatesChannels = createSelector(
  [selectUserSettingsOptionsResult],
  (result) => result.data?.newsAndUpdatesChannels ?? [],
);

export const selectAppThemes = createSelector(
  [selectUserSettingsOptionsResult],
  (result) => result.data?.themes ?? [],
);

export const selectAddressTypes = createSelector(
  [selectUserSettingsOptionsResult],
  (result) => result.data?.addressTypes ?? [],
);

export const selectUserModelsKit = createSelector(
  [selectUser],
  (user) => user?.modelsKit ?? [],
);
